<!--
 * =====================================================================
 * 작 업 명  : 회원정보삭제
 * 파 일 명  : Edit.vue
 * 변경이력
 * 2022-02-16 / 경다찬 / 최초작성
 * 2022-02-17 / 임태민 / 추가작성
 * =====================================================================
 -->
<template>
	<h3 class="title mt-5 text-center">
		<button class="btn rounded-circle border-0 bg-whites" @click="arrowClick()">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="32"
				height="42"
				fill="currentColor"
				class="bi bi-arrow-left-short"
				viewBox="0 0 16 16"
			>
				<path
					fill-rule="evenodd"
					d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
				></path>
			</svg>
		</button>
		Delete Account
	</h3>
	<div class="border-bottom mb-4"></div>
	<h6 class="title text-center mb-4">
		Once the deletion process begins, you won't be able to reactivate your
		account or retrieve any of information you have added.
	</h6>
	<div class="row mb-4">
		<div class="col-sm-4"></div>
		<div class="col-sm-4 list-group-item rounded-3">
			<h6 class="title mt-3 mb-4">
				Are you sure you want to delete your account?
			</h6>
			<div class="form-floating mb-3">
				<input
					type="text"
					class="form-control"
                    id="user-id"
					v-model="user.USER_ID"
					readonly
				/>
				<label for="user-id">Username</label>
			</div>
			<div class="form-floating mb-5">
				<textarea
					class="form-control"
                    id="floatingTextarea2"
					v-model="EXPIRE_REASON"
					style="height: 200px"
				></textarea>
				<label for="floatingTextarea2">Why are you deleting your account? (optional)</label>
			</div>
			<div class="row">
				<div class="col mb-3 d-flex justify-content-end">
					<button type="button" class="btn btn-dark" @click="invalidateClick()">
						Delete account
					</button>
				</div>
			</div>
		</div>
		<div class="col-sm-4"></div>
	</div>
</template>
<script>
import { $global, $axios, $error } from "@/dot-ui/index.js";
import { router } from "@/router/index.js";

export default {
	data() {
		return {
			user: {
				USER_NO: localStorage.getItem("_USER_NO_"),
				USER_ID: localStorage.getItem("_USER_ID_"),
			},
            EXPIRE_REASON: "",
			fromParams: "",
		};
	},
	created()
    {
		this.fromParams = $global.getUrlParams();
	},
	mounted()
    {
		this.search();
	},
	methods:
    {
		async search() {
			let fromSiteNo = this.fromParams.s;
			let fromCompNo = this.fromParams.c;
			let fromUserNo = this.fromParams.u;
			let url = `/user-app/v1/sites/${fromSiteNo}-${fromCompNo}/users/${this.user.USER_NO || fromUserNo}`
			let response = await $axios.get(url, {}, true);

			if (response.status == 200) {
				let json = response.data;
				this.user = json;
			} else {
				$error.showMessage(response, this);
			}
		},
		async invalidateClick() {
      let fromSiteNo = this.fromParams.s;
      let fromCompNo = this.fromParams.c;
			let url = `/user-app/v2/users/me?SITE_NO=${fromSiteNo}&COMP_NO=${fromCompNo}&USER_ID=${this.user.USER_ID}`;
			let response = await $axios.delete(url, null, true);

			if (response.status == 200) {
				let json = response.data;
				if (json.RESULT_CODE == "1") {
					await router.push({
            path: "/login",
            query: {
              cb: this.fromParams.cb,
              s: this.fromParams.s,
              c: this.fromParams.c,
            },
          });
					this.closeWebView();
				} else {
					$error.showMessage(response, this);
				}
			}
		},
		// 뒤로가기 클릭
		arrowClick()
        {
			router.push({
                path: "/basic",
                query: {
                    cb: this.fromParams.cb,
                    s: this.fromParams.s,
                    c: this.fromParams.c,
                },
            });
		},
		closeWebView() {
			if (window.webkit) {
				window.webkit.messageHandlers.deleteAccount.postMessage("close");
			}
		}
	},
};
</script>
<style>
</style>
